import UserAccountUpdate from './UserAccountUpdate';

export default UserAccountUpdate;
